import React, { useState, useEffect, useMemo } from "react";
import SideNavClass from './SideNavClass'
import { isIOS, isMobile } from 'react-device-detect';
import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCardFooter, MDBCardHeader, MDBCheckbox, MDBChip, MDBCol, MDBDatepicker, MDBIcon, MDBInput, MDBListGroup, MDBListGroupItem, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBPopconfirm, MDBPopconfirmMessage, MDBRadio, MDBRow, MDBSelect, MDBTimepicker, MDBTypography } from 'mdb-react-ui-kit';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import PhoneInput from 'react-phone-number-input';
import { checkMembershipDiscount, createMembers, downloadclassinvoice, getBussinessInfobyUrl, getCancellationPolicy, getStaffInfo, getClass, getClassBookingInfo, getGymPlansList, getSchedule, getWaiverSettingsbyGymid, memberByNumber, updateWaiverSettings } from "../../services/classApiServices.js";
import MemberVerify from "../../components/class/MemberVerify";
import DigitalWaiver from "../DigitalWaiver";
import ScheduleInvoice from "./ScheduleInvoice";
import { useLocation } from 'react-router';
import deleteImg from "./../../components/images/delete.svg";
import booklogo from "../../landingpage/assets/images/easybook.png";
import Price from "../../components/Price";
import BookingSuccess from "../../components/class/BookingSuccess";
import YourBookings from "../../components/class/YourBookings";
import ClassBookingLogin from "../../components/class/ClassBookingLogin";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import listPlugin from '@fullcalendar/list';
import { Link, useNavigate } from "react-router-dom";
import { idToSlug, slugToId } from '../../utils/slug';
import copy from 'clipboard-copy';
import EventDetailPage from "../../components/class/eventDetails";
import axios from "axios";




const localizer = momentLocalizer(moment);



const SchudeleCalender = () => {
    const [weekendsVisible, setWeekendsVisible] = useState(true)
    const [basicModal, setBasicModal] = useState(false);
    const cancelOpen = () => setBasicModal(!basicModal);
    const [policyinfo, setPolicyinfo] = useState([])
    const [refresh, setRefresh] = useState(false)
    const [scheduleData, setScheduleData] = useState(null)
    const [scheduleInfo, setScheduleInfo] = useState([])
    const [classes, setClasses] = useState([])
    const [policyData, setPolicyData] = useState([])
    const [trainerData, setTrainerData] = useState([])
    const [number, setNumber] = useState("")
    const [memeberInfo, setMemberInfo] = useState([])
    const [popupModal, setPopupModal] = useState(false);
    const togglepopupOpen = () => setPopupModal(!popupModal);

    const [centredModal, setCentredModal] = useState(false);
    const [bookaClass, setbookaClass] = useState(false);
    const [selectedMembers, setSelectedMembers] = useState([]);
    console.log(selectedMembers, '00000000000');
    const [waiverModal, setWaiverModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const [selectedevent, setSelectedevent] = useState(null)
    const [bussinessinfo, setbusinessinfo] = useState(null)
    const [plans, setPlans] = useState([])
    const [rightOpen, setRightOpen] = useState(false);
    // const [ugsttax, setUgsttax] = useState([]);
    let slotlimit = 0
    const [members, setMembers] = useState([
        { id: 1, firstName: "", lastName: "", phone: "", email: "" },
    ]);
    const [copyLink, setcopyLink] = useState(false);
    const [selectedClass, setSelectedClass] = useState([]);
    const [selectedTrainer, setSelectedTrainer] = useState([]);
    const [selectKey, setSelectKey] = useState(0);
    const [schedulModal, setscheduModal] = useState(false);
    const scheduleopen = () => setscheduModal(!schedulModal);
    const [eventdata, setEventdata] = useState(null)

    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };

    const [ip, setIp] = useState()
    useEffect(() => {
        const fetchIPAddress = async () => {
            try {
                const url = "https://api.ipify.org?format=json";
                const res = await axios.get(url);

                const ipAddress = res.data.ip;
                setIp(ipAddress);

            } catch (error) {
                console.error("Error fetching IP address:", error);
            }
        };

        fetchIPAddress();
    }, []);

    function decryptId(encryptedId) {
        return atob(encryptedId);
    }


    const handleShare = async () => {
        try {
            console.log(eventdata?.extendedProps?.scheduleinfo?._id, 'eventshare');

            const slug = idToSlug(eventdata?.extendedProps?.scheduleinfo?._id);
            const params = new URLSearchParams(window.location.search);
            const id = params.get("id");

            let shareUrl;

            if (id) {
                shareUrl = `${window.location.origin}${window.location.pathname}?id=${id}&sid=${slug}`;
            } else {
                shareUrl = `${window.location.origin}${window.location.pathname}?sid=${slug}`;
            }

            if (navigator.share) {
                await navigator.share({
                    title: eventdata?.title || 'Event Invitation',
                    text: [
                        `Join me for: ${eventdata?.title}`,
                        eventdata?.extendedProps?.date && `When: ${eventdata?.extendedProps?.date}`,
                        eventdata?.extendedProps?.location && `Where: ${eventdata?.extendedProps?.location}`,
                        eventdata?.extendedProps?.trainer && `Host: ${eventdata?.extendedProps?.trainer}`,
                        eventdata?.extendedProps?.description && `Details: ${eventdata?.extendedProps?.description}`
                    ].filter(Boolean).join('\n\n'),
                    url: shareUrl
                });
            }
        } catch (err) {
            console.log('Share failed:', err);
        }
    };

    const handlecopyDomainuserUrl = () => {
        const slug = idToSlug(eventdata?.extendedProps?.scheduleinfo?._id);
        // const shareUrl = `${window.location.origin}?sid=${slug}`;
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");

        let shareUrl;

        if (id) {

            shareUrl = `${window.location.origin}${window.location.pathname}?id=${id}&sid=${slug}`;
        } else {

            shareUrl = `${window.location.origin}${window.location.pathname}?sid=${slug}`;
        }

        copy(shareUrl);
        console.log("Share URL:", shareUrl);
        // copy(shareUrl)
        setcopyLink(true);
    }


    const handlepolicy = (eventinfo) => {
        setPolicyinfo(eventinfo)
        setBasicModal(true)
        setscheduModal(false);
    }

    const isFutureEvent = (event) => {
        const endDate = new Date(event?.end);
        const combinedEndDateTime = moment(endDate)
            .set({
                hour: moment(eventdata?.extendedProps?.endTime, "hh:mm A").hour(),
                minute: moment(eventdata?.extendedProps?.endTime, "hh:mm A").minute(),
                second: 0,
            })
            .toDate();

        return new Date() < combinedEndDateTime;
    };

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const userGymURL = params.get('id') ? params.get('id') : "";
    let userEventGymURL = params.get('sid') ? params.get('sid') : "";
    const hostname = window.location.hostname;
    let subdomain = "";
    console.log(hostname, 'hostname');

    if (hostname.endsWith('easymembr.com') || hostname.endsWith('zencruz.com')) {
        const parts = hostname.split('.');
        if (parts.length === 3 && parts[0] !== 'www' && parts[0] !== "app" && parts[0] !== "beta") {
            subdomain = parts[0];
        }
    }

    console.log('Query Param ID:', userGymURL);
    console.log('Subdomain:', subdomain);

    const navigate = useNavigate();
    useEffect(() => {
        const fetchBusiness = async () => {
            const identifier = subdomain || userGymURL;
            const type = subdomain ? 'subdomain' : 'prefix';

            const response = await getBussinessInfobyUrl(identifier, type);

            if (!response || response === "false") {
                return;
            }

            const businessInfo = await response.json();
            console.log(businessInfo);
            setbusinessinfo(businessInfo);
        };

        if (subdomain || userGymURL) {
            fetchBusiness();
        }
    }, []);

    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };


    useEffect(() => {
        if (isIOS) {
            setRightOpen(false)
        }
    }, [])

    useEffect(() => {
        async function fetchData() {
            const response = await getClassBookingInfo(bussinessinfo._id, "class");
            if (!response || response === "false") {
                return;
            }

            const tempData = await response.json();
            console.log(tempData, "tempData");

            const currentDate = new Date();

            const filteredSchedules = (tempData?.scheduleinfo || []).filter(schedule => {
                const startDate = new Date(schedule?.startdate);
                const visibledaysbefore = parseInt(schedule?.visibledaysbefore || 0, 10);

                const diffInMs = startDate - currentDate;
                const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

                const includeEvent = Math.abs(diffInDays) <= visibledaysbefore;


                return includeEvent;
            });




            setPlans(tempData?.plansinfo || []);
            setScheduleInfo(filteredSchedules);
            // setScheduleInfo(tempData?.scheduleinfo);
            setClasses(tempData?.classinfo || []);
            setPolicyData(tempData?.cancelationinfo || []);
            setTrainerData(tempData?.staffinfo || []);
        }

        if (bussinessinfo && bussinessinfo._id) {
            fetchData();
        }


    }, [bussinessinfo, refresh]);


    function generateUniqueKey(length) {
        const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let uniqueKey = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            uniqueKey += characters.charAt(randomIndex);
        }
        return uniqueKey;
    }
    console.log(bussinessinfo);

    const [uniqueid, setuniqueid] = useState("")
    const [classLimit, setClassLimit] = useState(0)
    useEffect(() => {
        const fetchWaiverdetails = async () => {
            const waiverRes = await getWaiverSettingsbyGymid(
                bussinessinfo._id, "class"
            );
            if (waiverRes === "false") {
                // setApiError(true)
            } else {
                const waiver = await waiverRes.json();
                console.log(waiver);
                if (!waiver.gymid) {
                    const updates = {
                        gymid: bussinessinfo._id,
                        uniqueNumber: generateUniqueKey(6),
                        emergencycontact: 2,
                        bloodgroup: 2,
                        address: 2,
                        phone: 1,
                        email: 1,
                        title: `Digital Waiver Form`,
                        checkboxcontent: `By checking this box, I acknowledge that I have read, understood, and agree to the terms and conditions
outlined in the waiver form. I accept full responsibility for my participation, or for the participation of the
minor I am legally responsible for, in climbing activities at Crag Studio, and recognize the inherent risks
involved.`,
                        agreement:
                            `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
deserunt mollit anim id est laborum`
                    }
                    let saverep = await updateWaiverSettings(updates, bussinessinfo._id, 'user');
                    const recinf = await saverep.json();
                    console.log(recinf.uniqueNumber);
                    // setWaiverForm(recinf);
                    setuniqueid(recinf.uniqueNumber ? recinf.uniqueNumber : "")
                } else {
                    // setWaiverForm(waiver);
                    setuniqueid(waiver.uniqueNumber ? waiver.uniqueNumber : "")
                }
            }
        }
        if (bussinessinfo && bussinessinfo._id) {
            fetchWaiverdetails()
        }

    }, [bussinessinfo])



    console.log(memeberInfo);

    let events = useMemo(() => {
        if (!Array.isArray(scheduleInfo) || !Array.isArray(classes) || !Array.isArray(trainerData) || !Array.isArray(policyData)) {
            return [];
        }
        const adjustStartWithTimeslot = (start, timeslot) => {

            console.log("start, timeslot", start, timeslot)


            if (!start || !timeslot) return new Date(start);

            const base = moment(start);

            const slotMoment = moment(timeslot, "hh:mm A");

            // Compare
            if (base.hour() === slotMoment.hour() && base.minute() === slotMoment.minute()) {
                // Times already match → just return backend date
                return base.toDate();
            }

            // Replace only time with slot
            const fixed = moment(base.format("YYYY-MM-DD") + " " + timeslot, "YYYY-MM-DD hh:mm A");
            return fixed.toDate();
        };



        return scheduleInfo
            .filter(schedule => schedule && schedule.classid && schedule.startdate && schedule.enddate)
            .map(schedule => {
                const classInfo = classes.find(cls => cls?._id === schedule.classid) || {};
                const trainer = trainerData.find(tr => tr?._id === schedule.trainerid) || {};
                const policy = policyData.find(pol => pol?._id === schedule.cancellationpolicyid) || {};
                const duration = parseInt(classInfo.duration, 10) || 0;

                const startMoment = moment(schedule?.timeslot, "hh:mm A");
                const endMoment = startMoment.clone().add(duration, 'minutes');
                const cancellationPolicy = policy?.cancelfee?.length > 0 ? policy.cancelfee.filter(fee => fee.checked) : '';
                const membership = classInfo?.membershipdiscount?.length > 0 ? classInfo?.membershipdiscount.filter(data => data.checked) : "";

                const mergedStart = adjustStartWithTimeslot(schedule.startdate, schedule?.timeslot);

                return {
                    id: schedule._id,
                    title: classInfo.name || "Unknown Class",
                    start: mergedStart,
                    end: new Date(schedule.enddate),
                    isprivate: schedule?.isprivate ? schedule.isprivate : false,
                    extendedProps: {
                        price: classInfo.price || 0,
                        trainer: `${trainer.firstname} ${trainer.lastname}` || "Unknown Trainer",
                        slotsBooked: schedule.bookedslots || 0,
                        slotsRemaining: schedule.totalslots ? schedule.totalslots : classInfo.slots || 0,
                        startTime: startMoment.format("hh:mm A"),
                        endTime: endMoment.format("hh:mm A"),
                        cancellationPolicy: cancellationPolicy,
                        eventType: !schedule.onetime ? `Recurring(${schedule?.recurrence?.recurrencetype})` : "One-Time",
                        description: classInfo?.description,
                        membershipdiscount: membership,
                        scheduleinfo: schedule,
                        classInfo: classInfo,
                        trainerInfo: trainer,
                    }
                };
            });
    }, [scheduleInfo, classes, trainerData, policyData]);

    const findEventById = (events, id) => {
        let event = events.find(item => item.id === id);
        if (!event) {
            const normalizedId = id.replace(/^0+/, '');
            event = events.find(item => item.id === normalizedId);
        }

        return event;
    };
    console.log(userEventGymURL, 'userEventGymURL');

    const eventId = slugToId(userEventGymURL);
    console.log(eventId, 'eventId');

    const filteredEvent = findEventById(events, eventId);
    console.log(filteredEvent, 'filteredEvent');
    // setSelectedEvent(filteredEvent)
    const toggleverifyMember = () => {
        setCentredModal(!centredModal);
        // setverifyOTP(!verifyOTP);
    };


    console.log(selectedClass, selectedTrainer);
    let eventinfo = events.filter(event => isFutureEvent(event) && event.isprivate !== true);
    if (selectedClass.length > 0 || selectedTrainer.length > 0) {
        const filteredSchedules = events.filter((event) => {
            const classId = event?.extendedProps?.classInfo?._id;
            const trainerId = event?.extendedProps?.trainerInfo?._id;

            // Apply both filters only if relevant selections exist
            const classMatch = selectedClass.length > 0 ? selectedClass.includes(classId) : true;
            const trainerMatch = selectedTrainer.length > 0 ? selectedTrainer.includes(trainerId) : true;

            // If class filter is applied, but no trainer match, exclude it
            if (selectedClass.length > 0 && !classMatch) return false;
            if (selectedTrainer.length > 0 && !trainerMatch) return false;
            if (event.isprivate === true) return false
            return true;
        });

        eventinfo = filteredSchedules.length > 0 ? filteredSchedules : [];

    }

    console.log(eventinfo, 'eventinfo');


    useEffect(() => {
        const fetchMembers = async () => {
            const membersinfo = await memberByNumber(bussinessinfo._id, { number: number }, "user")
            // console.log(membersinfo, '222222222222222222');
            if (!membersinfo || membersinfo === "false") {
                return;
            }
            const members = await membersinfo.json();

            console.log(members, 'members');
            setMemberInfo(members)
        }
        if (number != "" && (bussinessinfo && bussinessinfo._id)) {
            fetchMembers()
        }


    }, [number, refresh])

    console.log(number, '0000000000666666666');

    const togglebookaClass = () => {
        const storedNumber = sessionStorage.getItem("classnumber");
        const number = storedNumber ? JSON.parse(storedNumber) : null;
        setCentredModal(false);
        // setverifyOTP(false);
        setbookaClass(!bookaClass);
        setNumber(number)

    }

    const handleCheckboxChange = (memberId) => {
        setSelectedMembers((prevSelected) => {
            const isSelected = prevSelected.includes(memberId);
            const canAddMore = selectedevent?.slotsRemaining - selectedevent?.slotsBooked > prevSelected.length;


            if (!isSelected && !canAddMore) {
                alert("Slot limit has been reached");
                return prevSelected;
            }

            return isSelected
                ? prevSelected.filter((id) => id !== memberId)
                : [...prevSelected, memberId];
        });
    };

    const handleWaiver = () => {
        console.log(number, uniqueid, '888888888888888888888');
        const update = {
            number: number,
            uniqueid: uniqueid
        }
        setWaiverModal(true)
        localStorage.setItem("userInfo", JSON.stringify(update))

    }

    const callbackRefreshHandler = (event) => {
        // if (event == "save") {
        //     setRefresh(true)
        // }
        localStorage.removeItem("userInfo");
        setMembers([
            { id: 1, firstName: "", lastName: "", phone: "", email: "" },
        ]);

        setWaiverModal(false)

    }

    const handleclassevent = (event) => {
        console.log(event, '8888888888888888888886666666666666666666666644444444444444');
        setSelectedevent(event.extendedProps)
        setscheduModal(false);
        if (sessionStorage.getItem("classnumber")) {
            togglebookaClass()
        } else {
            toggleOpen()
        }


        // togglebookaClass()
    }

    const slotLimit = (event) => {
        return event?.extendedProps?.slotsRemaining - event?.extendedProps?.slotsBooked
    }

    const EventCard = ({ eventInfo }) => {
        const { event } = eventInfo;
        const [tooltipOpen, setTooltipOpen] = useState(false);

        const handleShare = async () => {
            try {
                console.log(event.extendedProps?.scheduleinfo?._id, 'eventshare');

                const slug = idToSlug(event.extendedProps?.scheduleinfo?._id);
                const params = new URLSearchParams(window.location.search);
                const id = params.get("id");

                let shareUrl;

                if (id) {
                    shareUrl = `${window.location.origin}${window.location.pathname}?id=${id}&sid=${slug}`;
                } else {
                    shareUrl = `${window.location.origin}${window.location.pathname}?sid=${slug}`;
                }

                if (navigator.share) {
                    await navigator.share({
                        title: event.title || 'Event Invitation',
                        text: [
                            `Join me for: ${event.title}`,
                            event.extendedProps?.date && `When: ${event.extendedProps.date}`,
                            event.extendedProps?.location && `Where: ${event.extendedProps.location}`,
                            event.extendedProps?.trainer && `Host: ${event.extendedProps.trainer}`,
                            event.extendedProps?.description && `Details: ${event.extendedProps.description}`
                        ].filter(Boolean).join('\n\n'),
                        url: shareUrl
                    });
                }
            } catch (err) {
                console.log('Share failed:', err);
            }
        };

        const handlecopyDomainuserUrl = () => {
            const slug = idToSlug(event.extendedProps?.scheduleinfo?._id);
            // const shareUrl = `${window.location.origin}?sid=${slug}`;
            const params = new URLSearchParams(window.location.search);
            const id = params.get("id");

            let shareUrl;

            if (id) {

                shareUrl = `${window.location.origin}${window.location.pathname}?id=${id}&sid=${slug}`;
            } else {

                shareUrl = `${window.location.origin}${window.location.pathname}?sid=${slug}`;
            }

            copy(shareUrl);
            console.log("Share URL:", shareUrl);
            // copy(shareUrl)
            setcopyLink(true);
        }


        useEffect(() => {
            const handleClickOutside = (event) => {
                if (!event.target.closest('.tooltip-content')) {
                    setTooltipOpen(false);
                }
            };

            document.addEventListener('click', handleClickOutside);
            return () => {
                document.removeEventListener('click', handleClickOutside);
            };
        }, []);
        const uniqueTooltipId = `tooltip-${event?.extendedProps?.scheduleinfo?._id || event.title}-${event.start}`;

        setClassLimit(event?.extendedProps?.slotsRemaining - event?.extendedProps?.slotsBooked)
        slotlimit = event?.extendedProps?.slotsRemaining - event?.extendedProps?.slotsBooked;
        // const isFutureEvent = () => {

        //     const endDate = new Date(event.end);

        //     const combinedEndDateTime = moment(endDate)
        //         .set({
        //             hour: moment(event.endTime, "hh:mm A").hour(),
        //             minute: moment(event.endTime, "hh:mm A").minute(),
        //             second: 0,
        //         })
        //         .toDate();

        //     return new Date() < combinedEndDateTime;
        // };
        const truncateContent = (content, maxLength) => {
            if (content && (content.length > maxLength)) {
                return content.substring(0, maxLength) + '...';
            } else {
                return content;
            }
        };


        const handlepolicy = (eventinfo) => {
            setPolicyinfo(eventinfo)
            setBasicModal(true)
        }

        const handleEventClick = () => {
            setEventdata(event)
            scheduleopen()
        }
        return (
            <div
                className=''
            >
                <div
                    className='d-flex align-items-start justify-content-center cursor-pointer w-100 flex-column slot_booked  p-1'
                    onClick={handleEventClick}
                    style={{
                        borderRadius: '5px',
                        color: '#000',
                        textTransform: 'capitalize',
                        zIndex: 1000,
                        maxHeight: '120px',
                        overflow: 'hidden',
                    }}
                >
                    <div className="d-flex justify-content-between triner-panel w-100" >
                        <div className="mb-1">
                            <p className='mb-0 text-truncate' style={{ maxWidth: '100%', textTransform: 'lowercase' }}>
                                <i class="fa-regular fa-clock me-1"></i> <span>  {event.extendedProps.startTime} to {event.extendedProps.endTime}</span>
                            </p>
                        </div>
                    </div>
                    <div className='mb-1'>
                        <label className="titel_name">{event.title}</label>
                        {/* <span > {event?.extendedProps?.slotsBooked}/{event?.extendedProps?.slotsRemaining}  Booked </span> */}
                    </div>


                    {/*<div className='ellipsis'>
                        <label className="titel_name">Description : </label>
                        <span
                            className='mb-0'
                            title={event.extendedProps.description}

                        >
                          
                            <div className="ps-0" title={stripHtmlTags(event.extendedProps.description ? event.extendedProps.description : "--")} dangerouslySetInnerHTML={{ __html: truncateContent(event.extendedProps.description ? event.extendedProps.description : "--", 300) }} />
                        </span>
                    </div>*/}
                    <div className="text-end w-100">
                        <label> <i class="fas fa-user me-1"></i> {
                            event?.extendedProps?.trainer ? event?.extendedProps?.trainer : "UnKnown Name"
                        }</label>
                    </div>
                </div>


                {/* <Tooltip
                    id={uniqueTooltipId}
                    events={['click']}
                    clickable
                    style={{ backgroundColor: "#FFFFFF" }}
                    className="m-0 p-0 rounded-5"
                    classNameArrow="example-arrow shadow-4"
                >

                    <MDBCard className="d-flex flex-column h-100">
                        <MDBCardHeader>
                            <div className="d-flex align-items-center justify-content-between">
                                <MDBTypography tag='h6' className="m-0 p-0">
                                    {event.title}
                                </MDBTypography>
                                <div className="d-flex align-items-center justify-content-center">
                                    <span className='text-primary fw-300 fs-6 cursor-pointer' onClick={handlecopyDomainuserUrl}><i class="fa-regular fa-copy"></i></span>
                                   
                                    <span className='share fw-300 fs-6 cursor-pointer ms-2' onClick={() => handleShare(event)}>
                                        <MDBIcon fas icon="share-alt" />
                                    </span>
                                  
                                </div>

                            </div>
                        </MDBCardHeader>
                        <MDBCardBody style={{ overflow: 'auto', maxHeight: '350px' }}>
                            <div className='d-flex align-items-center mb-2'>
                                <strong>
                                    Time:
                                </strong>
                                <p className='mb-0 ms-2'>
                                    {event?.extendedProps?.startTime} - {event?.extendedProps?.endTime}
                                </p>
                            </div>
                            <div className='d-flex align-items-center mb-2'>
                                <strong>
                                    Host:
                                </strong>
                                <p className='mb-0 ms-2'>
                                    {event?.extendedProps?.trainer}
                                </p>
                            </div>
                            <div className='d-flex align-items-center mb-2'>
                                <strong>
                                    Price:
                                </strong>
                                <p className='mb-0 ms-2'>
                                    {event?.extendedProps?.price}
                                </p>
                            </div>
                            <div className='d-flex align-items-center mb-2'>
                                <strong>
                                    Slots Booked:
                                </strong>
                                <p className='mb-0 ms-2 text-success'>
                                    {event?.extendedProps?.slotsBooked}
                                </p>
                            </div>
                            <div className='d-flex align-items-center mb-2'>
                                <strong>
                                    Slots Remaining:
                                </strong>
                                <p className='mb-0 ms-2 text-danger'>
                                    {event?.extendedProps?.slotsRemaining}
                                </p>
                            </div>
                            <div className='d-flex align-items-center mb-2'>
                                <strong>
                                    Event Type:
                                </strong>
                                <p className='mb-0 ms-2'>
                                    {event?.extendedProps?.eventType}
                                </p>
                            </div>
                            {event?.extendedProps?.membershipdiscount && event?.extendedProps?.membershipdiscount.length > 0 && <div className='mb-2'>
                                <label className="mb-1 fw-bold">
                                    Membership Discounts:
                                </label>
                                <div className=''>
                                    {event?.extendedProps?.membershipdiscount && event.extendedProps?.membershipdiscount.length > 0
                                        ? event.extendedProps?.membershipdiscount.map((item) => {
                                            const plan = plans.find((p) => p._id === item.membershipname);
                                            return (
                                                <ul className="m-0 ps-3">
                                                    <li className="p-1" key={item.membershipname}> {plan ? plan.name : "Unknown Plan"} - {item.discount}%</li>
                                                </ul>
                                            );
                                        })
                                        : (
                                            <p className="mb-0">No Membership Discounts available</p>
                                        )}
                                </div>
                            </div>}


                            <div className='d-flex align-items-start flex-column mb-2'>
                                <strong>
                                    Description:
                                </strong>
                              
                                <p className='mb-0 ms-2 custom-desc' title={stripHtmlTags(event?.extendedProps?.description ? event.extendedProps.description : "--")} dangerouslySetInnerHTML={{ __html: truncateContent(event.extendedProps.description ? event.extendedProps.description : "--", 300) }} />
                            </div>

                            {event?.extendedProps?.cancellationPolicy?.length > 0 ? <div className="Cancel-Policy">
                                <p className="m-0" onClick={() =>
                                    handlepolicy(event)
                                } >Cancellation Policy</p>
                            </div> : <div className="NoCancel-Policy">
                                <p className="m-0">Non Refundable</p>
                            </div>}
                        </MDBCardBody>
                        <MDBCardFooter className=''>
                            <div className='align-itema-end justify-content-end d-flex'>
                                <MDBBtn className={(isFutureEvent(event) && new Date(event.start).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) ? ((slotLimit(event)) === 0 ? "btn btn-warning" : 'btn btn-primary') : 'btn btn-danger'} onClick={(isFutureEvent(event) && new Date(event.start).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) ? ((slotLimit(event)) === 0 ? undefined : () => handleclassevent(event)) : undefined}>{(isFutureEvent(event) && new Date(event.start).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) ? ((slotLimit(event)) === 0 ? "Slots full" : "Book") : "Completed"}</MDBBtn>
                            </div>
                        </MDBCardFooter>
                    </MDBCard>
                </Tooltip> */}
            </div >
        );
    };


    const [invoiceCheck, setInvoiceCheck] = useState(false)
    const [error, setError] = useState(null)
    const handleBookclass = () => {
        if (selectedMembers.length > 0) {
            setInvoiceCheck(!invoiceCheck)
            setbookaClass(false);
        } else {
            setError("Please select a member")
        }

        // setbookaClass(!false);

    }
    const [success, setSuccess] = useState(false)
    const handleCallback = () => {
        console.log('7777777777777777777755555555555555');
        // setSuccess(true)
        setbookaClass(false);
        setscheduModal(false);
        setCentredModal(false);
        setInvoiceCheck(false);

        // Reset states
        setSelectedMembers([]);
        setSelectedevent(null);

        // Refresh data and show success
        setRefresh(true);
        setSuccess(true);

    }

    const homeCallback = () => {

    }
    const filteredMembers = memeberInfo && memeberInfo.length > 0 ? memeberInfo.filter(member => selectedMembers.includes(member._id)) : [];
    const [discountData, setDiscountData] = useState()

    useEffect(() => {
        const checkMembership = async () => {
            const update = {
                memebership: selectedevent?.classInfo?.membershipdiscount,
                memebersid: selectedMembers
            }
            const membersinfo = await checkMembershipDiscount(bussinessinfo._id, update, "user")
            if (!membersinfo || membersinfo === "false") {
                return;
            }
            const members = await membersinfo.json();
            // console.log(members, '000000000000000000000000000000000000');
            setDiscountData(members?.discountEligibleMembers ? members.discountEligibleMembers : [])
        }

        if (selectedevent && selectedevent?.classInfo && selectedevent?.classInfo?.membershipdiscount.length > 0) {
            checkMembership()

        }

    }, [invoiceCheck])



    const addNewRow = () => {
        setMembers([
            ...members,
            { id: members.length + 1, firstName: "", lastName: "", phone: "", email: "" },
        ]);
    }

    const removeRow = (id) => {
        setMembers(members.filter((member) => member.id !== id));
    };

    // Function to update member data
    const updateMember = (id, field, value) => {
        setMembers(
            members.map((member) =>
                member.id === id ? { ...member, [field]: value } : member
            )
        );
    };

    // Function to handle confirm button click
    const handleConfirm = async () => {
        console.log("Saved Members:", members);
        const update = {
            memberInfo: members,
            bid: bussinessinfo?._id
        }
        const res = await createMembers(bussinessinfo._id, update, "user")
        // console.log(res, '666666666666666666666666');
        const data = await res.json();
        // console.log(data, '8888888888888888888');

        if (data.membersdata && Array.isArray(data.membersdata)) {
            // Ensure prevMembers is always an array
            setMemberInfo(prevMembers => Array.isArray(prevMembers) ? [...prevMembers, ...data.membersdata] : [...data.membersdata]);
        }

        callbackRefreshHandler("save")
    };

    const [logcheck, setLogCheck] = useState(sessionStorage.getItem("classnumber") ? false : true)
    const callbacklogin = (from) => {
        setLogCheck(false)
        console.log(from, 'from');

        // setCentredModal(false)
        if (from == "book") {
            togglebookaClass()
        } else {
            setRightOpen(true)
        }

    }
    // console.log(number, 'bbbbbbbbbbbbbbbbbbbbbb', sessionStorage.getItem("classnumber"));

    const downloadInvoice = async (trans) => {
        try {
            if (trans == null) return
            console.log(trans, "trans");

            const update = {
                tid: trans.tid,
                bid: trans.bid,
                type: "class"
            }
            const response = await downloadclassinvoice(update, "user")

            const data = await response.json();
            console.log(data, "data");

            if (data.url) {
                const link = document.createElement("a");
                link.href = data.url;
                link.setAttribute("download", "filename.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error fetching signed URL", error);
        }
    }


    const handleNavigate = (path) => {
        navigate(path);
    }
    const [selectedEvent, setSelectedEvent] = useState(userEventGymURL)
    const handleevents = () => {
        setSelectedEvent("")
        // userEventGymURL = ""
    }

    console.log(userEventGymURL);

    const classOptions = classes.map(cls => ({
        text: cls.name,
        value: cls._id
    }));

    const trainerOptions = trainerData.map(tr => ({
        text: `${tr.firstname} ${tr.lastname}`,
        value: tr._id
    }));
    return (
        <>
            {!invoiceCheck && <>
                <div className="d-flex flex-column">
                    <div className="bookheader p-2 d-flex justify-content-between px-3 align-items-center">
                        <div className="d-flex align-items-center">
                            <img src={bussinessinfo?.logourl ? bussinessinfo?.logourl : booklogo} className="booklogoimg square border-end border-secondary pe-2" alt="Booklogo" />
                            <div className="ps-2 ">
                                <h5 className="mb-0">{bussinessinfo?.businessName ? bussinessinfo.businessName : "Easy Book"}</h5>
                                <label><i class="fas fa-map-marker-alt text-secondary"></i> {bussinessinfo?.city !== "" ? bussinessinfo?.city : (bussinessinfo?.state !== "" ? bussinessinfo?.state : "Hyderabad")}</label>
                            </div>
                        </div>
                        <div>
                            <h4 className='m-0'>
                                Book Slots
                            </h4>
                        </div>
                        <div className="">
                            <MDBBtn className="text-capitalize" outline color='success' onClick={() => setRightOpen(true)}>
                                <i class="fas fa-shopping-cart fs-6 me-2"></i>  <span className="fs-6"> Your Bookings </span>
                            </MDBBtn>
                        </div>
                    </div>
                    {selectedEvent ? <div className="overflow-hidden flex-1"><EventDetailPage event={filteredEvent} plans={plans} handleclassevent={handleclassevent} handleevents={handleevents} /></div> :
                        <div className="overflow-hidden flex-1 position-relative">
                            <div className="d-flex flex-wrap align-items-end gap-3 filter-table filter-data" style={{ zIndex: '999', top: '22px', left: '391' }}>

                                <div className="filter-select" style={{ minWidth: '200px', marginBottom: '20px' }}>
                                    <MDBSelect
                                        key={`class-select-${selectKey}`}
                                        clearButton
                                        data={classOptions}
                                        label="Filter Classes"
                                        multiple
                                        search
                                        selected={selectedClass}
                                        onChange={(data) => {
                                            const selectedValues = Array.isArray(data) ? data.map(item => item.value) : [];
                                            setSelectedClass(selectedValues);
                                            console.log('Selected class:', selectedValues, data);
                                        }}
                                    />
                                </div>

                                <div className="filter-select" style={{ minWidth: '200px', marginBottom: '20px' }}>
                                    <MDBSelect
                                        key={`trainer-select-${selectKey}`}
                                        clearButton
                                        data={trainerOptions}
                                        label="Filter Trainers"
                                        multiple
                                        search
                                        selected={selectedTrainer}
                                        onChange={(data) => {
                                            const selectedValues = Array.isArray(data) ? data.map(item => item.value) : [];
                                            setSelectedTrainer(selectedValues);
                                            console.log('Selected trainer:', data);
                                        }}
                                    />
                                </div>
                            </div>
                            <MDBCard className='shadow-0 h-100'>
                                <MDBCardBody className=' pt-1 d-flex flex-column'>  {/*custom-card-height */}

                                    <div className="overflow-hidden">
                                        <FullCalendar
                                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                                            initialView="listMonth"
                                            headerToolbar={{
                                                left: 'prev,next today',
                                                center: 'title',
                                                right: 'dayGridMonth,timeGridWeek,timeGridDay'
                                            }}
                                            buttonText={{
                                                listMonth: 'This Month',
                                                listWeek: 'This Week',
                                                listDay: 'This Day',
                                                listYear: "This Year"
                                            }}
                                            viewDidMount={(arg) => {
                                                const activeBtn = document.querySelector(`.fc-${arg.view.type}-button`);
                                                if (activeBtn) activeBtn.classList.add('fc-button-active');
                                            }}
                                            // editable={true}
                                            selectable={true}
                                            selectMirror={true}
                                            dayMaxEvents={true}
                                            weekends={weekendsVisible}
                                            events={eventinfo}
                                            eventContent={(eventInfo) => <EventCard eventInfo={eventInfo} />}
                                            height={'calc(100vh - 150px)'}
                                        />
                                    </div>


                                </MDBCardBody>
                            </MDBCard>
                        </div>}
                    <div className="business-details justify-content-between align-items-center">
                        <div className="d-flex">
                            <div className="d-flex align-items-center me-3 square border-end border-secondary pe-3">
                                <i class="fas fa-map-marker-alt text-secondary fs-5 me-2"></i>
                                <div className="b-title">
                                    <h6 className="mb-0">{bussinessinfo?.businessName ? bussinessinfo?.businessName : "Easy Book"}</h6>
                                    <span className="sub-value">
                                        {[
                                            bussinessinfo?.address,
                                            bussinessinfo?.city,
                                            bussinessinfo?.state,
                                            bussinessinfo?.country
                                        ].filter(Boolean).join(", ")}
                                    </span>
                                </div>

                            </div>
                            <div className="gym-contact me-3 d-flex align-items-center  pe-3">
                                <div className="conta-detail me-3">
                                    <span className="">Contact</span>
                                    <p className="cont-footer m-0"><a href={`https://wa.me/${bussinessinfo?.contactNumber ? bussinessinfo?.contactNumber : "+91 8019296262"}`} target='_blank' rel='noopener noreferrer'>
                                        {bussinessinfo?.contactNumber ? bussinessinfo?.contactNumber : "+91 8019296262"}
                                    </a></p>
                                </div>
                                <div className="conta-detail">
                                    <span className="m-0">E-mail</span>
                                    <p className="cont-footer m-0"> <a href={`mailto:${bussinessinfo?.businessEmail ? bussinessinfo?.businessEmail : "sales@easymembr.com"}`} target='_blank'>
                                        {bussinessinfo?.businessEmail ? bussinessinfo?.businessEmail : "sales@easymembr.com"}
                                    </a></p>
                                </div>
                            </div>
                        </div>
                        <div className="gym-contact links d-flex pe-3">
                            <p className="m-0  me-4" onClick={() => handleNavigate("/privacypolicy")}> <i class="fas fa-shield-alt me-1"></i> <span className=" "> <a href=""> Privacy Policy </a> </span></p>
                            <p className="m-0" onClick={() => handleNavigate("/terms")}> <i class="fas fa-ban me-1"></i>  <span className="" ><a href="">Terms and Conditions</a></span></p>
                        </div>
                    </div>
                </div>

                <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Verification</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody className="pb-2">
                                <MemberVerify togglebookaClass={togglebookaClass} toggleverifyclose={toggleverifyMember} callbacklogin={callbacklogin} from={"book"} />
                            </MDBModalBody>

                        </MDBModalContent>
                    </MDBModalDialog>


                </MDBModal>


                <MDBModal tabIndex='-1' open={bookaClass} onClose={() => setbookaClass(false)}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Book a Class</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={togglebookaClass}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <div>
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <label htmlFor="">
                                            <strong>Existing Members</strong>
                                        </label>
                                        <MDBBtn className="text-capitalize" onClick={handleWaiver}>
                                            <MDBIcon fas icon="plus" className="me-2" />
                                            Add Members
                                        </MDBBtn>
                                    </div>

                                    {memeberInfo && memeberInfo.length > 0 ? (
                                        memeberInfo.map((member, index) => (
                                            <MDBCheckbox
                                                key={member._id}
                                                id={`member-${index}`}
                                                label={`${member.fname} ${member.lname}, ${member.number}`}
                                                value={member._id}
                                                checked={selectedMembers.includes(member._id)}
                                                onChange={(e) => handleCheckboxChange(e.target.value)}
                                            />
                                        ))
                                    ) : (
                                        <p>No matching member found. Please add the member through the <bold>Waiver</bold> form.</p>
                                    )}
                                </div>
                            </MDBModalBody>
                            <MDBModalFooter className='pe-2 pb-2'>
                                <MDBBtn color='secondary' onClick={togglebookaClass}>
                                    Cancel
                                </MDBBtn>
                                <MDBBtn onClick={handleBookclass}>Confirm</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                <MDBModal tabIndex='-1' open={waiverModal} onClose={() => callbackRefreshHandler("close")}>
                    <MDBModalDialog size="lg">
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Add Member</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={() => callbackRefreshHandler("close")}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>

                                <div className="d-flex align-items-center justify-content-end mb-4">
                                    <MDBIcon
                                        fas
                                        icon="add"
                                        style={{ cursor: "pointer" }}
                                        onClick={addNewRow}
                                        className="ripple ripple-surface ripple-surface-light btn btn-primary fs-5"
                                    />
                                </div>

                                <MDBRow className="">
                                    {members.map((member, index) => (
                                        <>
                                            <MDBCol md={1} className="mb-3">
                                                <div className="d-flex flex-column">
                                                    {index == 0 && <label className="fw-bold mb-2">
                                                        S.No
                                                    </label>}
                                                    <label>{member.id}.</label>
                                                </div>
                                            </MDBCol>

                                            <MDBCol md={2} className="mb-3">
                                                <div className="d-flex flex-column">
                                                    {index == 0 && <label className="fw-bold mb-2">
                                                        First Name
                                                    </label>}
                                                    <input
                                                        className="payment_methods_input w-100"
                                                        type="text"
                                                        value={member.firstName}
                                                        onChange={(e) => updateMember(member.id, "firstName", e.target.value)}
                                                    />
                                                </div>
                                            </MDBCol>


                                            <MDBCol md={2} className="mb-3">
                                                <div className="d-flex flex-column">
                                                    {index == 0 && <label className="fw-bold mb-2">
                                                        Last Name
                                                    </label>}
                                                    <input
                                                        className="payment_methods_input w-100"
                                                        type="text"
                                                        value={member.lastName}
                                                        onChange={(e) => updateMember(member.id, "lastName", e.target.value)}
                                                    />
                                                </div>
                                            </MDBCol>



                                            <MDBCol md={3} className="mb-3">
                                                <div className="d-flex flex-column">
                                                    {index == 0 && <label className="fw-bold mb-2">
                                                        Phone Number
                                                    </label>}
                                                    <PhoneInput
                                                        className="payment_methods_input w-100"
                                                        defaultCountry="IN"
                                                        placeholder="Mobile Number"
                                                        value={member.phone}
                                                        onChange={(value) => updateMember(member.id, "phone", value)}
                                                    />
                                                </div>
                                            </MDBCol>




                                            <MDBCol md={3} className="mb-3">
                                                <div className="d-flex flex-column">
                                                    {index == 0 && <label className="fw-bold mb-2">
                                                        Email
                                                    </label>}
                                                    <input
                                                        className="payment_methods_input w-100"
                                                        type="email"
                                                        value={member.email}
                                                        onChange={(e) => updateMember(member.id, "email", e.target.value)}
                                                    />
                                                </div>
                                            </MDBCol>



                                            <MDBCol md={1} className="mb-3">
                                                <div className="d-flex flex-column">
                                                    {index == 0 && <label className="fw-bold mb-2">
                                                        Action
                                                    </label>}
                                                    <div className="" onClick={() => removeRow(member.id)}>
                                                        <img src={deleteImg} width="15px" alt="Delete" />
                                                    </div>
                                                </div>
                                            </MDBCol>


                                        </>
                                    ))}
                                </MDBRow>

                                <div className="payments d-none">
                                    <ul className="mb0">
                                        <div className="d-flex align-items-center mb-2">
                                            <label className="fw-bold w-5 payment_methods_input border-0 ms-5">
                                                S.No
                                            </label>
                                            <label className="fw-bold w-20 payment_methods_input border-0 ms-5">
                                                First Name
                                            </label>
                                            <label className="fw-bold w-20 payment_methods_input border-0">
                                                Last Name
                                            </label>
                                            <label className="fw-bold w-20 payment_methods_input border-0">
                                                Phone Number
                                            </label>
                                            <label className="fw-bold w-20 payment_methods_input border-0">
                                                Email
                                            </label>
                                            <label className="fw-bold w-20 payment_methods_input border-0">
                                                Action
                                            </label>
                                        </div>

                                        {members.map((member) => (
                                            <li key={member.id} className="Business__Details__data">
                                                <div className="d-flex align-items-center ms-4">
                                                    <span className="ms-4">  <label >{member.id}.</label>   </span>
                                                    <span className="ms-4">
                                                        <input
                                                            className="payment_methods_input me-2"
                                                            type="text"
                                                            value={member.firstName}
                                                            onChange={(e) => updateMember(member.id, "firstName", e.target.value)}
                                                        />
                                                    </span>
                                                    <span>
                                                        <input
                                                            className="payment_methods_input me-2"
                                                            type="text"
                                                            value={member.lastName}
                                                            onChange={(e) => updateMember(member.id, "lastName", e.target.value)}
                                                        />
                                                    </span>
                                                    <span className="d-flex">
                                                        <PhoneInput
                                                            className="payment_methods_input"
                                                            defaultCountry="IN"
                                                            placeholder="Mobile Number"
                                                            value={member.phone}
                                                            onChange={(value) => updateMember(member.id, "phone", value)}
                                                        />
                                                    </span>
                                                    <span className="d-flex ms-3">
                                                        <input
                                                            className="payment_methods_input"
                                                            type="email"
                                                            value={member.email}
                                                            onChange={(e) => updateMember(member.id, "email", e.target.value)}
                                                        />
                                                    </span>
                                                    <span>
                                                        <button type="button" className="ml20 button-link" onClick={() => removeRow(member.id)}>
                                                            <img src={deleteImg} width="15px" alt="Delete" />
                                                        </button>
                                                    </span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </MDBModalBody>

                            <MDBModalFooter className="pe-2 pb-2">
                                <MDBBtn color="secondary">Cancel</MDBBtn>
                                <MDBBtn onClick={handleConfirm}>Add Member(s)</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>


                </MDBModal>

                <MDBModal tabIndex='-1' open={basicModal} onClose={() => setBasicModal(false)} >
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Cancellation Policy</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={cancelOpen}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p className="mb-3 text-muted" style={{ fontSize: "14px" }}>
                                    If you cancel your booking before the class starts, a cancellation fee will be applied based on the number of days remaining.
                                    The fee percentage below indicates how much will be deducted, and the rest will be refunded.
                                </p>

                                <table className="Cancel_table">
                                    {/* <thead>
                                        <tr>
                                            <th>Day</th>
                                            <th>Fee</th>
                                        </tr>
                                    </thead> */}
                                    <tbody>

                                        {policyinfo?.extendedProps?.cancellationPolicy && policyinfo?.extendedProps?.cancellationPolicy?.length > 0 ? (
                                            policyinfo.extendedProps.cancellationPolicy.map(element => (
                                                <tr key={element._id} className='mb-0'>
                                                    <td>{element.days} Day(s) Before</td>
                                                    <td>{element.feevalue}% Fee</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={2}>Non Refundable</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </MDBModalBody>

                            <MDBModalFooter>
                                <MDBBtn color='secondary' onClick={cancelOpen}>
                                    Close
                                </MDBBtn>

                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

            </>}
            {
                invoiceCheck && (<div>
                    <ScheduleInvoice scheduleinfo={selectedevent} selectedMembers={selectedMembers} memeberInfo={filteredMembers} bussinessinfo={bussinessinfo} discountMembers={discountData} callbackUrl={handleCallback} downloadInvoice={downloadInvoice} Ip={ip} uniqueNumber={decryptId(params.get("id"))} />
                </div>)
            }
            {/* {isMobile && */}
            <div className="your-bookings">
                {bussinessinfo !== null && <YourBookings rightOpen={rightOpen} setRightOpen={setRightOpen} bussinessinfo={bussinessinfo} downloadInvoice={downloadInvoice} success={success} />}
            </div>
            {/* }  */}


            {/* {logcheck && <div>{!sessionStorage.getItem("classnumber") && <ClassBookingLogin callbacklogin={callbacklogin} />} */}
            {/* </div>} */}



            <MDBModal open={schedulModal} onClose={() => setscheduModal(false)} tabIndex='-1'>
                <MDBModalDialog size="md">
                    <MDBModalContent style={{ maxHeight: '70%' }}>
                        <MDBModalHeader>
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <MDBTypography tag='h6' className="m-0 p-0">
                                    {eventdata?.title}
                                </MDBTypography>
                                <div className='d-flex align-items-center'>
                                    <div >
                                        <span className='text-primary fw-300 me-2 cursor-pointer primary-icon' title="Copy"
                                            onClick={handlecopyDomainuserUrl}
                                        ><i class="fa-regular fa-copy "></i></span>
                                        {/* {navigator.share && ( */}
                                        <span className='share fw-300  cursor-pointer me-2  primary-icon' title="share"
                                            onClick={() => handleShare(eventdata)}
                                        >
                                            <MDBIcon fas icon="share-alt" />
                                        </span>
                                        {/* )} */}
                                    </div>

                                    {isFutureEvent() && (<>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <span className='text-primary fw-300 fs-6 cursor-pointer' onClick={handlecopyDomainuserUrl}><i class="fa-regular fa-copy"></i></span>

                                            <span className='share fw-300 fs-6 cursor-pointer ms-2' onClick={() => handleShare(eventdata)}>
                                                <MDBIcon fas icon="share-alt" />
                                            </span>

                                        </div>
                                    </>)}
                                    <MDBBtn className='btn-close ms-3' color='none' onClick={scheduleopen}></MDBBtn>
                                </div>
                            </div>
                        </MDBModalHeader>
                        <MDBModalBody className='p-3 pt-4'
                            // onClick={() => handleclick(eventdata)}
                            style={{ cursor: "pointer" }}>

                            {eventdata?.extendedProps?.cancellationPolicy?.length > 0 ? <div className="Cancel-Policy">
                                <p className="m-0" onClick={() =>
                                    handlepolicy(eventdata)
                                } >Cancellation Policy</p>
                            </div> : <div className="NoCancel-Policy">
                                <p className="m-0">Non Refundable</p>
                            </div>}



                            <table className="table table-striped table-bordered compressed-table mb-0">
                                <tbody>
                                    <tr>
                                        <td width="150px">Time</td>
                                        <td> {eventdata?.extendedProps?.startTime} - {eventdata?.extendedProps?.endTime}</td>
                                    </tr>
                                    <tr>
                                        <td>  Host</td>
                                        <td>{eventdata?.extendedProps?.trainer ? eventdata?.extendedProps?.trainer : "UnKnown Name"}</td>
                                    </tr>

                                    <tr>
                                        <td>Price</td>
                                        <td> Rs. {eventdata?.extendedProps?.price} /-</td>
                                    </tr>
                                    <tr>
                                        <td>Slots</td>
                                        <td className="text-success">  {eventdata?.extendedProps?.slotsBooked}/{eventdata?.extendedProps?.slotsRemaining} Booked</td>
                                    </tr>
                                    <tr>
                                        <td> Event Type</td>
                                        <td>{eventdata?.extendedProps?.eventType}</td>
                                    </tr>

                                    <tr>
                                        <td> Membership Discounts</td>
                                        <td>
                                            <div className=''>
                                                {eventdata?.extendedProps?.membershipdiscount && eventdata?.extendedProps?.membershipdiscount.length > 0
                                                    ? eventdata?.extendedProps?.membershipdiscount.map((item) => {
                                                        const plan = plans.find((p) => p._id === item.membershipname);
                                                        return (
                                                            <ul className="m-0 ps-3">
                                                                <li className="p-1" key={item.membershipname}> {plan ? plan.name : "Unknown Plan"} - {item.discount}%</li>
                                                            </ul>
                                                        );
                                                    })
                                                    : (
                                                        <p className="mb-0">No Membership Discounts available</p>
                                                    )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td> Description</td>
                                        <td><p className='mb-0 ms-2 custom-desc' title={stripHtmlTags(eventdata?.extendedProps?.description ? eventdata?.extendedProps?.description : "--")} dangerouslySetInnerHTML={{ __html: truncateContent(eventdata?.extendedProps?.description ? eventdata?.extendedProps?.description : "--", 300) }} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </MDBModalBody>

                        <MDBModalFooter className="px-3 pb-2">
                            <MDBBtn color='secondary' onClick={scheduleopen}>
                                Close
                            </MDBBtn>
                            <MDBBtn className={(isFutureEvent(eventdata) && new Date(eventdata?.start).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) ? ((slotLimit(eventdata)) === 0 ? "btn btn-warning" : 'btn btn-primary') : 'btn btn-danger'} onClick={(isFutureEvent(eventdata) && new Date(eventdata?.start).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) ? ((slotLimit(eventdata)) === 0 ? undefined : () => handleclassevent(eventdata)) : undefined}>{(isFutureEvent(eventdata) && new Date(eventdata?.start).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) ? ((slotLimit(eventdata)) === 0 ? "Slots full" : "Book") : "Completed"}</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>







            {
                error !== null && <MDBAlert
                    color={'danger'}
                    autohide
                    position='top-center'
                    delay={5000}
                    appendToBody
                    open={error != null ? true : false}
                    onClose={() => setError(null)}
                >
                    {error}
                </MDBAlert>
            }
            <MDBAlert
                color='success'
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={copyLink}
                onClose={() => setcopyLink(false)}
            >Link copied to clipboard!
            </MDBAlert>


        </>
    )
}


export default SchudeleCalender
